

import React from 'react'
// import Header from './Header'
// import Footer from './Footer'
import Error from '../assets/images/Error-404.svg'
import '../assets/css/notfound.css'
import {Link} from 'react-router-dom' 

const NotFound = () => (
  <div className="pagenotfound">
    <img src={Error} alt="" />
    {
      !localStorage.getItem('userInfo') ? 
      <Link to="/" className="btn btn-primary btn-block mt-4">
        <i className="fa fa-angle-left"></i> Go Back Home
      </Link> 
      : 
      <Link to="/dashboard" className="btn btn-primary btn-block mt-4">
        <i className="fa fa-angle-left"></i> Go Back Home
      </Link>
    }
  </div>
);

export default NotFound;
